export const DATEPICKER_BASE_CLASS = 'dp-datepicker';
export const DATEPICKER_CALENDAR_CLASS = 'dp-datepicker-calendar';
export const DATEPICKER_CALENDAR_ITEM_CLASS = 'dp-datepicker-item';

export const DATEPICKER_CALENDAR_ITEM_INLINE_CLASS = 'dp-datepicker-item-inline';
export const DATEPICKER_CALENDAR_ITEM_SINGLE_DATE_CLASS = 'dp-datepicker-single-date';
export const DATEPICKER_CALENDAR_ITEM_RANGE_FROM_CLASS = 'dp-datepicker-range-from';
export const DATEPICKER_CALENDAR_ITEM_RANGE_TO_CLASS = 'dp-datepicker-range-to';

export const DATEPICKER_FIRST_DAY_OF_WEEK = 'mon';

export const DATEPICKER_MAXIMUM_VIEW_DAY = 'day';
export const DATEPICKER_MAXIMUM_VIEW_MONTH = 'month';
export const DATEPICKER_MAXIMUM_VIEW_YEAR = 'year';
export const DATEPICKER_MAXIMUM_VIEW = [
  DATEPICKER_MAXIMUM_VIEW_DAY,
  DATEPICKER_MAXIMUM_VIEW_MONTH,
  DATEPICKER_MAXIMUM_VIEW_YEAR,
];

export const DATEPICKER_MODE_SINGLE = 'single';
export const DATEPICKER_MODE_RANGE = 'range';
export const DATEPICKER_MODES = [
  DATEPICKER_MODE_SINGLE,
  DATEPICKER_MODE_RANGE,
];

export const DATEPICKER_RANGE_FROM_PREFIX = 'rangeFromPrefix';

export const DATEPICKER_RANGE_TO_PREFIX = 'rangeToPrefix';

export const DATEPICKER_DATE_FORMAT = 'dd.MM.yyyy';

export const DATEPICKER_PLACEHOLDER = 'dd.mm.yyyy';

export const DATEPICKER_POSITIONS = [
  'auto',
  'bottom',
  'bottom-left',
  'bottom-right',
  'top',
  'top-left',
  'top-right',
];

export const DATEPICKER_DEFAULT_TRANSLATIONS = {
  language: 'English',
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  yearSuffix: '',
  labelDate: 'Date',
  labelFrom: 'From',
  labelTo: 'To',
};
